import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./grid.script";
export function RuiGrid({
  rows,
  label,
  children,
  ...props
}) {
  const content = rows != null ? rows.map(row => /* @__PURE__ */jsx("div", {
    class: "rui-grid__row",
    role: "row",
    children: row.map(cell => /* @__PURE__ */jsx("div", {
      class: "rui-grid__cell",
      role: "gridcell",
      tabindex: -1,
      children: cell
    }))
  })) : children;
  return /* @__PURE__ */jsx("rui-grid", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-grid",
      "data-ref": "root",
      role: "grid",
      "aria-label": label || void 0,
      children: content
    })
  });
}